const BLOG_TAG_LOADING = "BLOG_TAG_LOADING";
const BLOG_TAG_ERROR = "BLOG_TAG_ERROR";
const BLOG_TAG_SUCCESS = "BLOG_TAG_SUCCESS";

export { BLOG_TAG_ERROR, BLOG_TAG_SUCCESS, BLOG_TAG_LOADING };
